import { PageHeader } from "@shared/components/PageHeader";
import { Tabs } from "@shared/ui/tabs";
import React from "react";
import SegmentLanding from "../tabs/segment/landing/landing";
import EmailSignatureLanding from "../tabs/emailSignature/landing/landing";

const SettingsLanding = () => {
  return (
    <div>
      <PageHeader
        title="Settings"
        subtitle="Manage your application settings and configurations"
      />
      <div className="flex flex-col space-y-4 mt-3">
        <div className="w-full overflow-hidden">
          <Tabs
            defaultValue="segments"
            className="w-full"
            tabsListClassName="grid w-full grid-cols-2 mb-6 p-1"
            urlMapping={{
              segments: "segments",
              emailSignature: "emailSignature",
            }}
            tabComponents={{
              segments: {
                label: "Segments",
                component: <SegmentLanding />,
              },
              emailSignature: {
                label: "Email Signature",
                component: <EmailSignatureLanding />,
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SettingsLanding;
